import ObjectTableController from "./object_table_controller"

export default class ExchangeMarketSalesObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    listTypeFriendlyName: "sale",
    subjectType: "sale",
    parentSubjectType: "market",
    enableEdit: false,
    isFavouriteEnabled: false,
  }
}
